import { DrawerBody, Flex } from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { Drawer } from '~/components/Drawer';

import { useAdvancedFiltersStore } from '../../store/useAdvancedFilterStore';
import { useCreatorsFiltersStore } from '../../store/useCreatorsFiltersStore';
import { ClearAllFiltersButton } from '../ClearAllFiltersButton';
import { GenderFilters } from './GenderFilters';
import { SearchByAge } from './SearchByAge';
import { SearchByFollowers } from './SearchByFollowers';
import { SearchByLocation } from './SearchByLocation';
import { VerticalFilters } from './VerticalFilters';

export function TalentFilters() {
  const {
    isCreatorsFiltersDrawerOpen,
    closeCreatorsFiltersDrawer,
    clearAllFilters,
  } = useCreatorsFiltersStore();

  const { clearFilters } = useAdvancedFiltersStore();

  const handleClearFilters = useCallback(() => {
    clearAllFilters();
    clearFilters();
  }, [clearAllFilters, clearFilters]);

  return (
    <Drawer
      isOpen={isCreatorsFiltersDrawerOpen}
      title="Talent Filters"
      onClose={closeCreatorsFiltersDrawer}
      closeOnOverlayClick={isCreatorsFiltersDrawerOpen}
      onOverlayClick={closeCreatorsFiltersDrawer}
      contentProps={{
        width: '100%',
        maxWidth: { base: '100%', md: '360px' },
      }}
    >
      <DrawerBody>
        <Flex flexDirection="column" gap={6}>
          <SearchByFollowers />
          <GenderFilters />
          <SearchByLocation />
          <SearchByAge />
          <VerticalFilters />
          <ClearAllFiltersButton
            title="Clear All Filters"
            onClear={handleClearFilters}
          />
        </Flex>
      </DrawerBody>
    </Drawer>
  );
}
